import {Fragment, useEffect, useState, useContext} from 'react';

import BackStep from '../General/BackStep/BackStep';
import LoginContext from '../../../../../store/login-context';
import classes from './SummaryOptions.module.scss';
import bulb from '../../../../../assets/icons/bulb-fill-blue.svg';
import ProgressBar from '../ProgressBar/ProgressBar';

declare var _siteSettings: any;
declare function Translate(key: string): string;

const SummaryOptions = (props) => {
    const ctx = useContext(LoginContext);

    const [mainOptions, setMainOptions] = useState<string[]>([]);
    const [alternativeOptions, setAlternativeOptions] = useState<string[]>([]);
    const [binuyShikun, setBinuyShikun] = useState('');
    const [opt1, setOpt1] = useState(''); //sspr url parameter
    const [opt2, setOpt2] = useState(''); //sspr usrl parameter

    useEffect(() => {
        const userOptions = ctx.summaryRegOptions.slice();       
                   
         // Main Options
        if (userOptions.length > 0){           
            const mainOptionsIdsArr = userOptions[0].split(',');
            let translatedOptions = [''];
            let indx=0;
            mainOptionsIdsArr.forEach((option) => {
                switch (option) {                   
                    case "creditCard":
                        translatedOptions.push(Translate('N_Login_SignUp_Credit_Card_Data'));
                        indx === 0 ? setOpt1("cc") : setOpt2("cc");
                        break;
                    case "passport":
                        translatedOptions.push(Translate('N_Login_SignUp_Passport'));
                        indx === 0 ? setOpt1("ps") : setOpt2("ps");
                        break;
                    case "imiggrationCert":
                        translatedOptions.push(Translate('N_Login_SignUp_Immigration_Cert_Num'));
                        indx === 0 ? setOpt1("imc") : setOpt2("imc");
                        break;                              
                    default:
                        break;
                }
                indx = indx + 1;
            })

            translatedOptions.shift();
            setMainOptions(translatedOptions); 
                    
        }

        // Alternative Options
        if (userOptions.length > 1){            
            const alternativeOptionsIdsArr = userOptions[1].split(',');
            let translatedOptions = [''];
            let altIndx=0;
            let opt2Str="";
            alternativeOptionsIdsArr.forEach((option) => {
                switch (option) {
                    case "lastGoDate":
                        translatedOptions.push(Translate('N_Login_SignUp_Last_Exit_Date'));                        
                        altIndx === 0 ? opt2Str="lv" : opt2Str=opt2Str+"*lv";
                        break;
                    case "hmoMobile":
                        translatedOptions.push(Translate('N_Login_SignUp_hmo'));                       
                        altIndx === 0 ? opt2Str="hm" : opt2Str=opt2Str+"*hm";
                        break;
                    // case "idIssueDate":
                    //     translatedOptions.push(Translate('N_Login_SignUp_ID_Date'));                        
                    //     altIndx === 0 ? opt2Str="id" : opt2Str=opt2Str+"*id";
                    //     break;
                    case "personalChangeDate":
                        translatedOptions.push(Translate('N_Login_SignUp_Personal_Change_Date'));                        
                        altIndx === 0 ? opt2Str="pr" : opt2Str=opt2Str+"*pr";
                        break;
                    case "oldCitizen":
                        translatedOptions.push(Translate('N_General_SignUp_senior_tooltip'));
                        altIndx === 0 ? opt2Str="vt" : opt2Str=opt2Str+"*vt";
                        break;
                    case "foreignPassportNum":
                        translatedOptions.push(Translate('N_Login_SignUp_Foreign_Passport_Num'));
                        altIndx === 0 ? opt2Str="fps" : opt2Str=opt2Str+"*fps";
                        break;
                    case "immigrationDate":
                        translatedOptions.push(Translate('N_Login_SignUp_Immigration_Date'));
                        altIndx === 0 ? opt2Str="imd" : opt2Str=opt2Str+"*imd";
                        break;
                    case "weapon":
                        translatedOptions.push(Translate('N_General_SignUp_FireArm_Number'));
                        altIndx === 0 ? opt2Str="wpn" : opt2Str=opt2Str+"*wpn";
                        break;
                    case "nationalInsurance":
                        translatedOptions.push(Translate('N_Login_SignUp_National_Insurance_Bank_Title'));
                        altIndx === 0 ? opt2Str="nIn" : opt2Str=opt2Str+"*nIn";
                        break;
                    default:
                        break;
                }
                altIndx = altIndx + 1;
            });
            
            translatedOptions.shift();
            setAlternativeOptions(translatedOptions); 
            
            // Binuy Shikun
            if(userOptions.length > 2){
                if(userOptions[2] === "binuyShikun"){
                    setBinuyShikun(Translate('N_Login_SignUp_Shikun_Summary_Title'));
                    opt2Str=opt2Str+"*bn";
                }            
            }

            setOpt2(opt2Str);
        }
                       
    },[]);

    const onBackStepHandler = () => {
        props.prevScreen(); 
    }

    const handleContinueClick = () => {
        if(ctx.PreRegUser.length > 0){
            debugger;
            window.location.href = 
                _siteSettings.signupLink + 
                        "&userid=" + ctx.PreRegUser[0] +
                        "&usermail=" + ctx.PreRegUser[1] + 
                        "&userphone=" + ctx.PreRegUser[2] +
                        "&opt1=" + opt1 +
                        "&opt2=" + opt2 ;     
        } 
        else{
            debugger;
            window.location.href = _siteSettings.signupLink;        
        } 
    };


    return(
        <Fragment>
            <ProgressBar pbWidth="100%"/>
            <div className={classes.container}>
                
                <BackStep prevStep = {onBackStepHandler} />
            
                <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_General_SignUp_Options_Summary_Title')}</div>

                <div className={classes.options_container}>                   
                    {mainOptions.map((option, index) => (                                              
                        <div key={index}>
                            <span className={classes.hyphen}>&#8208;</span>
                            <span className={classes.summary_text}>{option}</span>
                        </div>
                    ))} 
                    {alternativeOptions.map((option, index) => (                                              
                        <div key={index}>
                            <span className={classes.hyphen}>&#8208;</span>
                            <span className={classes.summary_text}>{option}</span>
                        </div>
                    ))} 
                    {binuyShikun.length > 0 &&
                        <>
                            <div>
                                <span className={classes.hyphen}>&#8208;</span>
                                <span className={classes.summary_text}>{binuyShikun}</span>
                            </div>
                            <div className={classes.bullet_container}>
                                <div>
                                    <span className={classes.bullet}>&#x2022;</span>
                                    <span className={classes.bullet_text}>{Translate('N_Login_SignUp_Shikun_Account_Num')}</span>
                                </div>
                                <div>
                                    <span className={classes.bullet}>&#x2022;</span>
                                    <span className={classes.bullet_text}>{Translate('N_Login_SignUp_Shikun_Rent_Date')}</span>
                                </div>
                                <div>
                                    <span className={classes.bullet}>&#x2022;</span>
                                    <span className={classes.bullet_text}>{Translate('N_Login_SignUp_Shikun_Support_Amount')}</span>
                                </div>
                            </div>
                        </>
                    }                        
                </div>                               
                <div className={`preRegText ${classes.desc}`}>
                    <img src={bulb} alt="bulb" className={classes.bulb}/>
                    <span className={classes.desc_text}>{Translate('N_General_SignUp_Options_Advice')}</span>                        
                </div>                                    
                <div className={classes.buttons_container}>                   
                    <button 
                        className={classes.btn_continue} 
                        id='btnSummary' 
                        onClick={handleContinueClick}
                    >
                        <span>{Translate('N_Login_Bio_ID_continue_button')}</span>                     
                    </button>
                </div>
                
            </div>          
        </Fragment>      
    );
};
export default SummaryOptions;